import React from 'react';
import {
    Avatar,
    Box,
    Divider,
    makeStyles,
    Typography,
    useMediaQuery,
    useTheme,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { user } from '€slices/user';
// import { initials } from '€lib/fp';
import DetailsReminder from './DetailsReminder';
import SettingsOptions from './SettingsOptions';
import AboutUs from './AboutUs';
import LogoutOption from './LogoutOption';
import { settingsMenuOptions, detailsReminderContent } from '€lib/userProfile';

const useStyles = makeStyles(theme => ({
    avatar: {
        backgroundColor: theme.palette.primary.main,
        width: matches => `${matches ? '6.4rem' : '9.6rem'}`,
        height: matches => `${matches ? '6.4rem' : '9.6rem'}`,
    },
}));

const UserSettings: React.FunctionComponent = () => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    const classes = useStyles(matches);
    const $user = useSelector(user);
    const { subTitle, description } = detailsReminderContent;

    // const fullName = useMemo(
    //     () => $user && `${$user.profile.firstName} ${$user.profile.lastName}`,
    //     [$user],
    // );

    return (
        <Box>
            <Box
                display="flex"
                flexDirection="column"
                alignItems={matches ? 'flex-start' : 'center'}
            >
                <Avatar className={classes.avatar}>{$user.initials}</Avatar>
                <Box mt={2}>
                    <Typography variant="h4">{$user.name}</Typography>
                </Box>
            </Box>
            {!matches && (
                <>
                    <Box my={4}>
                        <Divider />
                    </Box>
                    <DetailsReminder subTitle={subTitle} description={description} />
                </>
            )}
            <SettingsOptions menuOptions={settingsMenuOptions} />
            <AboutUs />
            <LogoutOption />
        </Box>
    );
};

export default UserSettings;
